export function addStyles(formattedDataOld) {
  let formattedData = formattedDataOld;
  //replace ql clssses with css styles #without indentation added
  if (formattedData.includes('class="ql-align-right"')) {
    formattedData = formattedData.replace(/class=\"ql-align-right\"/g, 'style="text-align: right;"');
  }
  if (formattedData.includes('class="ql-align-center"')) {
    formattedData = formattedData.replace(/class=\"ql-align-center\"/g, 'style="text-align: center;"');
  }

  // replace ql clssses with css styles #with indentation added
  //format: <p class=\"ql-align-center ql-indent-3\">
  if (formattedData.includes('class="ql-align-right ')) {
    formattedData = formattedData.replace(/class=\"ql-align-right /g, 'style="text-align: right;" class="');
  }
  if (formattedData.includes('class="ql-align-center ')) {
    formattedData = formattedData.replace(/class=\"ql-align-center /g, 'style="text-align: center;" class="');
  }

  //format: <p class=\"ql-indent-5 ql-align-center\">
  if (formattedData.includes(' ql-align-right">')) {
    formattedData = formattedData.replace(/ ql-align-right\">/g, '" style="text-align: right;">');
  }
  if (formattedData.includes(' ql-align-center">')) {
    formattedData = formattedData.replace(/ ql-align-center\">/g, '" style="text-align: center;">');
  }

  return formattedData;
}

export function addAlignmentsForAPP(question) {
  /* To Add alignments for question as per Congigurator for App (Android and IOS) */
  if (question.formattedBody && !!question.formattedBody) {
    question.formattedBody = addStyles(question.formattedBody);
  }

  if (question.formattedTitle && !!question.formattedTitle) {
    question.formattedTitle = addStyles(question.formattedTitle);
  }

  if (question.formattedInformation && !!question.formattedInformation) {
    question.formattedInformation = addStyles(question.formattedInformation);
  }

  if (question.type == "CustomScale") {
    if (question.formattedLabels && !!question.formattedLabels && question.formattedLabels.length > 0) {
      question.formattedLabels.map(label => {
        return addStyles(label);
      });
    }
  } else if (question.type == "DropDown" || question.type == "MultiChoice") {
    if (question.options && !!question.options && question.options.length > 0) {
      question.options.map(option => {
        option.formattedBody = addStyles(option.formattedBody);
      });
    }
  } else if (question.type == "Index") {
    //Index Rows
    if (question.rows && !!question.rows && question.rows.length > 0) {
      const rows = question.rows;
      for (const index in rows) {
        rows[index] = addStyles(rows[index]);
      }
    }

    //Index Columns
    if (question.cols && !!question.cols && question.cols.length > 0) {
      const cols = question.cols;
      for (const index in cols) {
        cols[index] = addStyles(cols[index]);
      }
    }

    //Index Values
    if (question.indexValues && question.indexValues.length > 0) {
      question.indexValues.map(index => {
        index.map(data => {
          data.value = addStyles(data.value);
        });
      });
    }
  }
}
